/* istanbul ignore file */
import { colors } from '@noths/polaris-client-ribbons-design-system';
import {
  createGrid,
  hideScrollbar,
  maxBreakpoints,
  mediaQuery,
  minBreakpoints,
  pxToRem,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts, text } = theme;

const largeScreenGrid = createGrid(7);

export const productLabel = css`
  position: absolute;
  left: 0;
  top: ${pxToRem(15)};
`;

export const imagesWrapper = css`
  overflow-y: hidden;
  margin: 0 -${spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      overflow-y: visible;
      margin: 0;
      position: sticky;
      top: ${pxToRem(spacing.lg)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      top: ${pxToRem(spacing.xl)};

      ${largeScreenGrid}
    `,
  )}
`;

export const mainImageWrapperWithThumbnails = css`
  position: relative;
  display: flex;
  overflow-x: auto;
  scroll-behavior: auto;
  scroll-snap-type: x mandatory;

  ${hideScrollbar}

  &[data-image-focus='true'] {
    box-shadow: 0 0 0 ${pxToRem(3)} ${colors.neutralWhite},
      0 0 0 ${pxToRem(5)} ${colors.brandBluePrimary};
  }

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM, max: maxBreakpoints.MEDIUM },
    css`
      margin: 0 0 ${pxToRem(spacing.md)};
      border-radius: ${pxToRem(10)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      border-radius: ${pxToRem(20)};
    `,
  )}
`;

export const carouselSlide = css`
  scroll-snap-align: center;
  min-width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${colors.neutralLighter};
`;

export const carouselContainer = css`
  position: relative;

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 2 / -1;
    `,
  )}
`;

const mainImageBorderRadius = css`
  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      border-radius: ${pxToRem(10)};
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      border-radius: ${pxToRem(20)};
    `,
  )}
`;

export const mainImageWrapperNoThumbnails = css`
  align-items: center;
  background-color: ${colors.neutralLighter};
  display: flex;
  height: 0;
  overflow: hidden;
  padding-bottom: 100%;
  position: relative;

  ${mainImageBorderRadius}

  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 1 / -1;
    `,
  )}
`;

export const mainImageLink = css`
  display: block;
  flex-basis: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.focus-visible:focus {
    outline: none !important;
    box-shadow: none;
  }

  ${mainImageBorderRadius}
`;

export const mainImage = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const fresnelThumbnails = css`
  ${mediaQuery(
    { min: minBreakpoints.LARGE },
    css`
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    `,
  )}
`;

export const carouselNavigationButton = css`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  background-color: ${colors.neutralWhite};
  border: none;
  border-radius: 50%;
  padding: 10px;

  &.focus-visible {
    outline: none;

    &:before {
      content: '';
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      border-radius: 50%;
      border: ${colors.brandBluePrimary} 2px solid;
    }

    &:after {
      content: '';
      position: absolute;
      top: -6px;
      bottom: -6px;
      left: -6px;
      right: -6px;
      border-radius: 50%;
      border: ${colors.neutralLighter} 2px solid;
    }
  }
`;

export const prevNavigationButton = css`
  left: ${pxToRem(spacing.md)};

  img {
    transform: rotate(180deg);
  }
`;

export const nextNavigationButton = css`
  right: ${pxToRem(spacing.md)};
`;

export const progressIndicator = css`
  position: absolute;
  right: ${pxToRem(spacing.md)};
  bottom: ${pxToRem(spacing.md)};
  background-color: ${colors.neutralWhite};
  border-radius: ${pxToRem(10)};
  padding: 0 ${pxToRem(8)};
  margin: 0;
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
